export type AccountLogoReplacedPayload = {
	accountId: number;
};

export type AccountLogoReplacedAction = {
	type: 'ACCOUNT_LOGO_REPLACED';
	payload: AccountLogoReplacedPayload;
};

export default (payload: AccountLogoReplacedPayload): AccountLogoReplacedAction => ({
	type: 'ACCOUNT_LOGO_REPLACED',
	payload,
});
